module.exports = __webpack_public_path__ + "static/media/pickle_mar_squares.bcfc8d6b.png";